import { SyncLoader, ClipLoader } from "react-spinners";
import styles from './loading.module.css'
export default function Loading({type , style}) {
    return <div className={styles.loadingElement} style={style}>
        {!type ? <ClipLoader
            color="#662D91"
            size={80}
            speedMultiplier={.7}
            aria-label="Loading Spinner"
            data-testid="loader"
        /> : <SyncLoader 
            color="#662D91"
            ize={40}
            speedMultiplier={.4}
            aria-label="Loading"
            data-testid="loader"
        />}
    </div>
} 